// extracted by mini-css-extract-plugin
module.exports =  {"title":"a867bdd7c0--title--VHnm1","description":"a867bdd7c0--description--RB50g","tooltip":"a867bdd7c0--tooltip--ionul"};